import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  FormGroup,
  Input,
  Label,
  Collapse,
} from "reactstrap"
import Select from "react-select"
import { AvForm, AvField } from "availity-reactstrap-validation"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// import "./datatables.scss"
import CustomTable from "components/Table/Table"

export const SuccessStories = () => {
  // ---------------------Collapse Start-------------------------
  const [faq1, setFaq1] = useState(false)
  // ---------------------Collapse End-------------------------

  const [SuccessStories_Modal, setSuccessStories_Modal] = useState(false)

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function AddSuccessStories_Modal() {
    setSuccessStories_Modal(!SuccessStories_Modal)
    removeBodyCss()
  }

  const [selectedGroup, setselectedGroup] = useState(null)
  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const optionStatus = [
    {
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
    },
  ]

  const optionCandidate = [
    {
      options: [
        { label: "Nilesh Soni", value: "Nilesh Soni" },
        { label: "Krishna Soni", value: "Krishna Soni" },
      ],
    },
  ]

  const [totalSize, setTotalSize] = useState(3)

  const data = {
    columns: [
      {
        text: "Story Title",
        dataField: "StoryTitle",
        style: { width: "12%" },
      },
      {
        text: "Stories Date",
        dataField: "StoriesDate",
        style: { width: "8%" },
      },
      {
        text: "Stories Person Name",
        dataField: "StoriesPersonName",
        style: { width: "12%" },
      },
      {
        text: "Stories Person Mobile",
        dataField: "StoriesPersonMobile",
        style: { width: "11%" },
      },
      {
        text: "Stories Person Email Id",
        dataField: "StoriesPersonEmailId",
        style: { width: "10%" },
      },
      {
        text: "Status",
        dataField: "Status",
        style: { width: "9%" },
      },
    ],
    rows: [
      {
        StoryTitle: "Nilesh Weds Krishna",
        StoriesDate: "01-OCT-2008",
        StoriesPersonName: "Nilesh D. Soni",
        StoriesPersonMobile: "+91 9601615060",
        StoriesPersonEmailId: "nileshsoni22@gmail.com",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddSuccessStories_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        StoryTitle: "Nilesh Weds Krishna",
        StoriesDate: "01-OCT-2008",
        StoriesPersonName: "Nilesh D. Soni",
        StoriesPersonMobile: "+91 9601615060",
        StoriesPersonEmailId: "nileshsoni22@gmail.com",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddSuccessStories_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        StoryTitle: "Nilesh Weds Krishna",
        StoriesDate: "01-OCT-2008",
        StoriesPersonName: "Nilesh D. Soni",
        StoriesPersonMobile: "+91 9601615060",
        StoriesPersonEmailId: "nileshsoni22@gmail.com",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddSuccessStories_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
    ],
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Success Stories | Matrimonial Admin</title>
        </MetaTags>
        <div className="container-fluid">
          <Row>
            <Breadcrumbs
              maintitle="Dashboard"
              title="Master"
              breadcrumbItem="Success Stories"
            />
            <Col sm={6}>
              <div className="float-end d-none d-md-block pt-2">
                <Button
                  color="primary"
                  className="btn btn-primary waves-effect waves-light mt-4"
                  onClick={() => {
                    AddSuccessStories_Modal()
                  }}
                  data-toggle="modal"
                  data-target=".bs-example-modal-lg"
                >
                  Add Success Stories
                </Button>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="accordion mb-3" id="accordionExample">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button font-size-15 faq"
                      style={{
                        backgroundColor: "rgb(164, 229, 207)",
                        height: "40px",
                        color: "#000",
                      }}
                      type="button"
                      onClick={() => {
                        setFaq1(!faq1)
                      }}
                    >
                      <i class="fas fa-filter"></i> &nbsp;Filter Success Stories
                      List
                    </button>
                  </div>
                  <Collapse isOpen={faq1} className="accordion-collapse">
                    <div className="accordion-body">
                      <Row>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Story Title</Label>
                            <Input type="text" name="Name" id="Name" />
                          </div>
                        </Col>

                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Stories Person Mobile</Label>
                            <Input type="text" name="MobileNo" id="MobileNo" />
                          </div>
                        </Col>

                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Stories Person Email Id</Label>
                            <Input type="text" name="Email" id="Email" />
                          </div>
                        </Col>

                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Status</Label>
                            <Select
                              value={selectedGroup}
                              onChange={() => {
                                handleSelectGroup()
                              }}
                              options={optionStatus}
                              classNamePrefix="select2-selection"
                            />
                          </div>
                        </Col>
                        <Col lg="12">
                          <div className="float-end d-none d-md-block pt-0">
                            <Button
                              color="primary"
                              className="btn btn-primary waves-effect waves-light mt-0"
                            >
                              Search
                            </Button>{" "}
                            <Button
                              color="outline-primary"
                              className="btn btn-outline-primary mt-0"
                            >
                              Clear
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Collapse>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {/* <MDBDataTable responsive bordered data={data} noBottomColumns/> */}
                  <CustomTable
                    keyField="SubscriptionList"
                    columns={data.columns}
                    data={data.rows}
                    totalSize={totalSize}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Modal
        size="lg"
        isOpen={SuccessStories_Modal}
        toggle={() => {
          AddSuccessStories_Modal()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            Add Success Stories
          </h5>
          <button
            onClick={() => {
              AddSuccessStories_Modal()
            }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <AvForm className="needs-validation">
            <Row>
              <Col md="4">
                <FormGroup className="mb-3">
                  <AvField
                    name="StoryTitle"
                    label="StoryTitle"
                    placeholder="Story Title"
                    type="text"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup className="mb-3">
                  <AvField
                    label="Stories Details"
                    name="StoriesDetails"
                    placeholder="Stories Details"
                    type="textarea"
                    className="form-control AddressTextarea"
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup className="mb-3">
                  <AvField
                    name="StoriesDate"
                    label="Stories Date"
                    type="date"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup className="mb-3">
                  <AvField
                    name="StoriesImage"
                    label="Stories Image"
                    placeholder="Stories Image"
                    type="file"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup className="mb-3">
                  <AvField
                    name="StoriesPersonName"
                    label="Stories Person Name"
                    placeholder="Stories Person Name"
                    type="text"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup className="mb-3">
                  <AvField
                    label="Stories Person Mobile"
                    name="StoriesPersonMobile"
                    placeholder="Stories Person Mobile"
                    type="number"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup className="mb-3">
                  <AvField
                    label="Stories Person Email Id"
                    name="StoriesPersonEmailId"
                    placeholder="Stories Person Email Id"
                    type="email"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup className="mb-3">
                  <AvField
                    label="Stories Remarks"
                    name="StoriesRemarks"
                    placeholder="Stories Remarks"
                    type="textarea"
                    className="form-control AddressTextarea"
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup className="mb-3">
                  <AvField
                    name="DocumentAttachment"
                    label="Document Attachment"
                    placeholder="Document Attachment"
                    type="file"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col lg="4">
                <div className="mb-3">
                  <Label>Candidate Profile Boy</Label>
                  <Select
                    value={selectedGroup}
                    onChange={() => {
                      handleSelectGroup()
                    }}
                    options={optionCandidate}
                    classNamePrefix="select2-selection"
                  />
                </div>
              </Col>

              <Col lg="4">
                <div className="mb-3">
                  <Label>Candidate Profile Girl</Label>
                  <Select
                    value={selectedGroup}
                    onChange={() => {
                      handleSelectGroup()
                    }}
                    options={optionCandidate}
                    classNamePrefix="select2-selection"
                  />
                </div>
              </Col>
            </Row>
            <Button color="primary" className="mt-3" type="submit">
              Submit
            </Button>{" "}
            <Button
              color="outline-primary"
              className="mt-3"
              onClick={() => {
                AddSuccessStories_Modal()
              }}
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              Cancel
            </Button>
          </AvForm>
        </div>
      </Modal>
    </React.Fragment>
  )
}
